import { Component } from '@angular/core';
import { MechanicsService } from '../_services/mechanics.service';

@Component({
  selector: 'dialog-video',
  templateUrl: './dialog-video.component.html',
  styleUrl: './dialog-video.component.css'
})
export class DialogVideoComponent {

	constructor(public ms:MechanicsService){
		
	}

}
